import React from 'react';
import { SPORTS_TO_SHOW_WITHOUT_TIME } from '../../data/constants';
import Jersey from '../../common/jerseys/Jersey';

function LiveMatchHeader(props) {
    return (
        <>
            {props.team2 == null ?
                <div className="info-evento-centrale d-flex justify-content-around align-items-center margine-giu-mezzo bordo-tondo">
                    <div className="squadra-evento squadra-casa justify-content-center">
                        {props.team1}
                    </div>
                </div>
                :
                <div className="info-evento-centrale d-flex justify-content-around align-items-center margine-giu-mezzo bordo-tondo">
                    <div className="squadra-evento squadra-casa margine-dx">
                        <Jersey className="xs_jersey_big" data={props.jerseys?.[0]} type={'home'} sportRef={props.sportRef} />
                        {props.team1}
                    </div>
                    <div className="punteggio-evento-centrale allinea-centro">
                        {props.score.currentMinute && !SPORTS_TO_SHOW_WITHOUT_TIME.has(props.sportRef) &&
                            <div className="riga colore-1 lampeggia">{props.score.currentMinute}</div>
                        }
                        {props.team1Score && props.team1Score.length > 0 && props.team2Score && props.team2Score.length > 0 &&
                            <div className="riga grassetto">
                                {props.team1Score}
                                <span className="trattino">:</span>
                                {props.team2Score}
                            </div>
                        }
                        {props.partialScores?.length > 0 ?
                            <div className="partial-scores-container">
                                {props.partialScores && props.partialScores.filter(s => s != null).map(s => {
                                    const key = Object.keys(s)[0]
                                    const value = s[key];
                                    const split = value && value.split("#");
                                    return value ?
                                        <div key={key} className="riga punteggio-parziale-evento-centrale">
                                            <span className="colore-1 grassetto" >{split[0].replace(/\s+/g, '')}</span>
                                            <span>({split[1].replace("-",":").replace(/\s+/g, '')})&nbsp;</span>
                                        </div>
                                        :
                                        null;
                                })}
                            </div>
                            :
                            <div className="partial-scores-container">
                                <div className="riga punteggio-parziale-evento-centrale">{props.score.periodo}</div>
                            </div>
                        }
                    </div>
                    <div className="squadra-evento squadra-trasferta margine-sx">
                        {props.team2}
                        <Jersey className="xs_jersey_big" data={props.jerseys?.[1]} type={'away'} sportRef={props.sportRef} />
                    </div>
                </div>
            }
        </>
    );
}

export default LiveMatchHeader;
